module.exports = __webpack_public_path__ + "img/20191125164012360截图20191125161955120.f3898f9c.jpg";